import { isNonEmptyString } from './isNonEmptyString'

export function formatString(...items: (string | undefined | null)[]) {
  return items.filter(isNonEmptyString).join(' ')
}
